import { createModule } from '~/factories/store'
import actions from '~/store/modules/shared/dealers/integration/classifieds/field/actions'
import getters from '~/store/modules/shared/dealers/integration/classifieds/field/getters'
import mutations from '~/store/modules/shared/dealers/integration/classifieds/field/mutations'
import state from '~/store/modules/shared/dealers/integration/classifieds/field/state'

export default createModule({
  actions,
  getters,
  mutations,
  state
})
